(function (M) {
  if (!M) return;
  var d = document, cd = d.querySelector('.cd');
  if (!cd) return;
  M.particles(cd, M.narrow ? 12 : 30);
  M.tag('.cd-hero > img', 'zoom');
  M.tag('.cd-hero .t > *', 'up', { d: 0.15, step: 0.14 });
  var h1 = d.querySelector('.cd-hero h1');
  if (h1) h1.classList.add('mo-shine');
  var intro = d.querySelector('.cd-intro p');
  if (intro) {
    M.tag(intro, 'up');
    M.count(intro, '12,000');
    M.add(intro,
      '<svg class="mo-ridge mo-deco" data-mo-play viewBox="0 0 360 70" aria-hidden="true">' +
      '<defs><linearGradient id="cdRidgeShade" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#C9A45C" stop-opacity=".22"/><stop offset="1" stop-color="#C9A45C" stop-opacity="0"/></linearGradient></defs>' +
      '<path class="sh" d="M0 64 L48 46 L76 52 L120 28 L148 38 L186 10 L214 34 L244 24 L282 44 L320 36 L360 52 V70 H0 Z"/>' +
      '<path class="ln" pathLength="1" d="M0 64 L48 46 L76 52 L120 28 L148 38 L186 10 L214 34 L244 24 L282 44 L320 36 L360 52"/>' +
      '<circle class="pk" cx="186" cy="10" r="3.5"/><text x="196" y="9">12,000 ft</text></svg>');
  }
  M.tag('.cd-intro img', 'zoom', { d: 0.1 });
  M.tag('.cd-intro2 img', 'left');
  M.tag('.cd-intro2 p', 'up', { d: 0.12 });
  M.all('.cd-prod').forEach(function (p) {
    M.tag(M.all('.cd-ttl h2', p), 'up');
    var row = p.querySelector('.cd-row');
    if (row) {
      row.classList.add('mo-halo');
      var img = row.querySelector(':scope > img');
      if (img) { M.tag(img, 'rise'); img.classList.add('mo-float'); }
      var info = row.querySelector(':scope > div');
      if (info) M.tag(M.all(':scope > *', info), 'up', { d: 0.2, step: 0.1 });
    }
    M.tag(M.all('.cd-desc p', p), 'up', { step: 0.12 });
  });
  M.tag('.b50-img img', 'zoom');
  var badge = d.querySelector('.b50-badge b');
  if (badge) {
    badge.classList.add('mo-ringed');
    badge.setAttribute('data-mo-play', '');
    badge.insertAdjacentHTML('afterbegin', '<svg class="mo-ring mo-deco" viewBox="0 0 62 62" aria-hidden="true"><circle cx="31" cy="31" r="29.5" pathLength="1"/></svg>');
    M.count(badge, '50');
  }
  var since = d.querySelector('.b50-since em');
  if (since) since.setAttribute('data-mo-drift', '70');
  M.tag('.b50-since', 'fade');
  M.tag('.b50-txt h2, .b50-txt p, .b50-txt .b50-cert', 'up', { step: 0.12 });
})(window.FJKMotion);
